export const getRowsFromFields = (fields) => {
    const rows = [];
    let currentRow = { id: Date.now().toString(), columns: [] };
    let currentWidth = 0;
  
    fields.forEach((field) => {
      const span =field.colSpan || 1;
  
      // Adjust: add buffer tolerance or cap at 4 max
      if (currentWidth + span > 4) {
        rows.push(currentRow);
        currentRow = { id: Date.now().toString() + Math.random(), columns: [] };
        currentWidth = 0;
      }
  
      currentRow.columns.push(field);
      currentWidth += span;
    });
  
    if (currentRow.columns.length > 0) {
      rows.push(currentRow);
    }
  
    return rows;
  };